import React from 'react';
import {t} from 'i18next';
import ArrModal from '../../common/arr-modal/ArrModal';

interface UnsavedChangesModalProps {
  showModal: boolean;
  onClose: () => void;
  onSave: () => void;
}

const UnsavedChangesPopup: React.FC<UnsavedChangesModalProps> = ({
  showModal,
  onClose,
  onSave,
}) => {
  return (
    <ArrModal
      showModal={showModal}
      ariaLabel={t('docRedactions.deleteRedactionModal.deleteRedaction')}
      title={t(
        'productionsAndExports.createNewProduction.common.unsavedChangesModal.title'
      )}
      ariaDescription={t('docRedactions.deleteRedactionModal.sureWantToDelete')}
      description={t(
        'productionsAndExports.createNewProduction.common.unsavedChangesModal.description'
      )}
      onClose={() => {
        onClose();
      }}
      autoFocusCloseButton={true}
      headerTitle={t(
        'productionsAndExports.createNewProduction.common.unsavedChangesModal.headerTitle'
      )}
      dataTestId="unsavedchangespopup-modal"
      buttons={[
        {
          id: 'no-button',
          label: t(
            'productionsAndExports.createNewProduction.common.unsavedChangesModal.btnCancel'
          ),
          dataTestId: 'ucp-no-button',
          onClick: () => {
            onClose();
          },
          variant: 'secondary',
          disabled: false,
        },
        {
          id: 'yes-button',
          label: t(
            'productionsAndExports.createNewProduction.common.unsavedChangesModal.btnLeave'
          ),
          dataTestId: 'ucp-yes-button',
          onClick: () => {
            onSave();
          },
          variant: 'primary',
          loading: false,
          disabled: false,
        },
      ]}
    />
  );
};

export default UnsavedChangesPopup;
